/* SB Photo Testimonials — mobile carousel: scale cards by distance from centre. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 989px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(root) {
    var track = root.querySelector('[data-sb-pt-track]');
    if (!track || track.dataset.sbPtInit === '1') return;
    track.dataset.sbPtInit = '1';

    var prev = root.querySelector('[data-sb-pt-prev]');
    var next = root.querySelector('[data-sb-pt-next]');
    var raf = null;

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('.sb-pt-card'));
    }

    function clear() {
      cards().forEach(function (c) {
        c.style.transform = '';
        c.style.opacity = '';
      });
    }

    function updateArrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    function step(dir) {
      var all = cards();
      if (!all.length) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      track.scrollBy({
        left: dir * (all[0].offsetWidth + gap),
        behavior: REDUCED.matches ? 'auto' : 'smooth'
      });
    }

    function update() {
      raf = null;
      updateArrows();
      if (!MOBILE.matches || REDUCED.matches) { clear(); return; }
      var rect = track.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      cards().forEach(function (c) {
        var r = c.getBoundingClientRect();
        var t = Math.min(Math.abs(r.left + r.width / 2 - mid) / r.width, 1);
        c.style.transform = 'scale(' + (1 - t * 0.1).toFixed(3) + ')';
        c.style.opacity = (1 - t * 0.3).toFixed(3);
      });
    }

    function queue() {
      if (raf === null) raf = window.requestAnimationFrame(update);
    }

    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', queue);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Start on the middle card so the carousel opens centred, then paint scales.
    if (MOBILE.matches) {
      var all = cards();
      var middle = all[Math.floor(all.length / 2)];
      if (middle && all.length > 1) {
        track.scrollLeft = middle.offsetLeft - (track.clientWidth - middle.offsetWidth) / 2;
      }
    }
    update();
  }

  function initAll() {
    document.querySelectorAll('.sb-photo-testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector && e.target.querySelector('.sb-photo-testimonials');
    if (s) initSection(s);
  });
})();
